import React, { useEffect, useState } from "react";
import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal.js";
import Cancel from "./../../../../assets/icons/close.png";
import itemImg from "./../../../../assets/icons/menu.png";
import CustomDataGrid from "../../../components/CustomDataGrid/CustomDataGrid.tsx";
import { ToastContainer, toast } from "react-toastify";
import Typography from "@mui/material/Typography";
import AutoCompleteMultiSelect from "../../../../pages/components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";

import axios from "axios";

import {
  Button,
  Grid,
  Switch,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Autocomplete
} from "@mui/material";

import jwt_decode from "jwt-decode";

function FooditemUnavailableDialog(props) {
  console.log(props);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [openMenuCloseConfirmaitonModal, setopenMenuCloseConfirmaitonModal] =
    useState(false);
  const [openArchiveConfirmaitonModal, setopenArchiveConfirmaitonModal] =
    useState(false);
  const [selectedValue, setSelectedValue] = useState([]);
  const [dataRows, setDataRows] = useState([]);

  const [selectedDataRows, setSelectedDatarows] = React.useState([]);

  const getselectedData = (props) => {
    console.log(props);
    setSelectedDatarows(props);
  };

  const handleClose = () => {
    setopenMenuCloseConfirmaitonModal(false);
    props.onHandleAddItem(false);
    setRestaurantAdded([]);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRowId(null);
  };

  const {
    open,
    onClose,
    dialogType,
    id,
    cancledRes,
    onToggleSwitch,
    addNewSec,
    selectedRestaurants,
    openDialog: toggle,
    selectedMenuId
  } = props;

  console.log(selectedMenuId);

  const apiAddress = process.env.REACT_APP_SECRET;

  const [restaurantId, setRestaurantId] = useState([]);

  const [foodItemSelected, setfoodItemSelected] = useState([]);
  const [copySectionId, setcopySectionId] = useState([]);

  const Restauranttoken = JSON.parse(localStorage.getItem("parentrestaurant"));
  const RestauranttokenLocal = JSON.parse(localStorage.getItem("restaurant"));
  const [restaurantDatas, setRestaurantDatas] = React.useState([]);
  const token = localStorage.getItem("gotasteadmintoken");
  const [userId, setUserId] = useState();

  const [restaurantAdded, setRestaurantAdded] = useState([
    { id: RestauranttokenLocal.id, title: RestauranttokenLocal.name },
  ]);

  const ReasonsList = [
    { id:"1", label: "Unavailable" },
    { id:"2", label: "kitchen breakdown" },
    { id:"3", label: "Out of stock" },
  ];
  const [ReasonSelected, setReasonSelected] = useState('');
  const [remarks, setRemarks] = useState('');
  const handleRemarks = (event) => {
    setRemarks(event.target.value);
  };
  const [hideSwitch, sethideSwitch] = useState(false);

  const handleHideSwitch = (event) => {
    sethideSwitch(!hideSwitch)
  };
  const [menuUnavailableView, setmenuUnavailableView] = useState({
  });

  const Submit = () => {

    var obj = {
      id: "123",
      fooditemId: selectedMenuId,
      reason:ReasonSelected.label ?? "",
      remarks:remarks ?? "",
      creatorId: "123"
    };

    if(selectedMenuId != undefined){
      var url = apiAddress + '/api/Fooditems/SetFooditemUnavailable?fooditemId='+selectedMenuId+'&isHide='+hideSwitch;
      console.log(obj)
      axios.put(url, obj).then((response) => {
        toast.success("Fooditem Deactivated", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        })
        props.onHandleAddItem(false);
      })
    };
  }
  

  useEffect(() => {
    console.log(ReasonSelected);
  }, [ReasonSelected]);
  useEffect(() => {
    console.log(remarks);
  }, [remarks]);

  return (
    <div>
      <React.Fragment>
        <Dialog
          maxWidth={"sm"}
          fullWidth={true}
          open={props.open}
          onClose={handleClose}
        >
          <SweetAlertModal
            headerText={"Do you want to leave without saving?"}
            bodyText={"All changes made will be lost"}
            open={openMenuCloseConfirmaitonModal}
            onyes={handleClose}
            close={() => {
              setopenMenuCloseConfirmaitonModal(false);
            }}
            id={2}
          />

          <SweetAlertModal
            headerText={"Are you sure?"}
            bodyText={"Performing this action will make this Food item unavailable."}
            open={openArchiveConfirmaitonModal}
            onyes={Submit}
            close={() => {
              setopenArchiveConfirmaitonModal(false);
            }}
          />
          <Grid container>
            <Grid item xs={9}>
              <DialogTitle>
                <div className="d-flex" style={{ gap: "8px" }}>
                  <div>
                    <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                  </div>

                  <span style={{ color: "#2a7fd4" }}>
                    GoTaste :- Fooditem Unavailable
                  </span>
                </div>
              </DialogTitle>
            </Grid>
            <Grid item xs={3}>
              <DialogActions>
                <Button onClick={() => setopenMenuCloseConfirmaitonModal(true)}>
                  <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
            <div>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={12} style={{ paddingTop: "1rem" }}>
                  <Autocomplete
                    disablePortal
                    options={ReasonsList}
                    //value={ReasonSelected}
                    onChange={(event, newInputValue) => {
                      setReasonSelected(newInputValue);
                    }}
                    renderInput={(params) => <TextField {...params} label="Reasons" />}
                  />
                </Grid>
              </Grid>
            </div>
            <div>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={12} >
                <TextField
                    id="outlined-multiline-static"
                    label="Remarks"
                    multiline
                    fullWidth
                    rows={4}
                    placeholder="Remarks"
                    onChange={handleRemarks}
                    value={remarks}
                  />
                </Grid>
              </Grid>
            </div>
            <div>
              <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={3}>
                  <Typography style={{ paddingTop: "0.5rem" }}>
                    Hide From View
                  </Typography>
                </Grid>
                <Grid item xs={9} >
                <Switch
                  checked={hideSwitch}
                  onChange={handleHideSwitch}
                  color="primary"
                  inputProps={{ "aria-label": "toggle" }}
                />
              </Grid>
              </Grid>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setopenArchiveConfirmaitonModal(true)}
              color="success"
            >
              Submit
            </Button>
            <Button
              onClick={() => props.onHandleAddItem(false)}
              color="error"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </div>
  );
}

export default FooditemUnavailableDialog;
